module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('pl-dialog', {
    attrs: {
      "size": "lg",
      "title": 'Edit Verbal Discussion',
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close', false)
      }
    }
  }, [_c('div', {
    staticClass: "h-full w-full pb-6 min-h-1/5 overflow-y-auto"
  }, [_c('div', {
    staticClass: "h-full flex flex-col"
  }, [_c('header', {
    staticClass: "pb-3 px-6"
  }, [_c('div', {
    staticClass: "w-full mb-3"
  }, [_c('h6', {
    staticClass: "mb-1 text-gray-700 font-medium"
  }, [_vm._v(" Title "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "bg-white focus-within:border-gray-400 border border-solid border-gray-200 rounded w-full py-2 px-3",
    attrs: {
      "placeholder": "Enter a title for Verbal RoundTable"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('main', {
    staticClass: "overflow-y-auto flex flex-col space-y-4 overflow-x-hidden h-full px-6 relative"
  }, [_c('div', {
    attrs: {
      "id": "instructions"
    }
  }, [_c('h6', {
    staticClass: "mb-2 text-gray-700 font-medium"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('div', {
    staticClass: "bg-trueGray-100 rounded border focus-within:border-gray-400 border-solid border-gray-200",
    staticStyle: {
      "height": "150px"
    }
  }, [_c('RichTextEditor', {
    attrs: {
      "id": "text-editor-verbal",
      "init": _vm.editor_options
    },
    model: {
      value: (_vm.instructions),
      callback: function($$v) {
        _vm.instructions = $$v
      },
      expression: "instructions"
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "flex justify-between items-center mb-2"
  }, [_c('h6', {
    staticClass: "text-blueGray-700 font-medium"
  }, [_vm._v("Content and Multimedia")])]), _vm._v(" "), _c('div', {
    staticClass: "relative bg-gray-100 overflow-y-auto rounded border border-solid border-gray-200 px-3 py-3"
  }, [_c('div', {
    staticClass: "flex justify-between items-center space-x-2",
    class: [{
      'pb-3': _vm.resource_questions.length > 0
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_resource_name),
      expression: "new_resource_name"
    }],
    staticClass: "bg-white focus-within:border-gray-400 w-full py-2 px-4 rounded border border-solid border-gray-200",
    attrs: {
      "placeholder": "Enter a Resource Name"
    },
    domProps: {
      "value": (_vm.new_resource_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_resource_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_resource_url),
      expression: "new_resource_url"
    }],
    staticClass: "bg-white focus-within:border-gray-400 w-full py-2 px-4 rounded border border-solid border-gray-200",
    attrs: {
      "placeholder": "Enter a Resource URL"
    },
    domProps: {
      "value": (_vm.new_resource_url)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.createEditResource.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_resource_url = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "bg-blueGray-700 text-white py-2 px-4 rounded",
    on: {
      "click": _vm.createEditResource
    }
  }, [_vm._v("\n                  Add\n                ")])]), _vm._v(" "), _c('Draggable', {
    staticClass: "h-full flex-grow overflow-y-auto",
    attrs: {
      "handle": ".handle"
    },
    on: {
      "start": function($event) {
        _vm.drag_content_resource = true
      },
      "end": function($event) {
        _vm.drag_content_resource = false
      }
    },
    model: {
      value: (_vm.resource_questions),
      callback: function($$v) {
        _vm.resource_questions = $$v
      },
      expression: "resource_questions"
    }
  }, _vm._l((_vm.resource_questions), function(resource, index) {
    return _c('div', {
      key: index,
      staticClass: "flex flex-col space-y-2"
    }, [_c('ResourceOption', {
      key: index,
      staticClass: "mb-1.5",
      attrs: {
        "resource_url": resource.resourceURL,
        "is_active": resource.is_active,
        "resource_name": resource.resourceName,
        "id": index
      },
      on: {
        "change_active_status": function (id_option) { return _vm.handleChangeResourceStatus(id_option); },
        "delete_resource_content": function (id_option) { return _vm.handleRemoveContentMultimedia(id_option); },
        "save_information_before_edit": function (info) { return _vm.handleEditResourceContent(info); }
      }
    })], 1)
  }), 0)], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "flex justify-between items-center mb-2"
  }, [_c('h6', {
    staticClass: "text-blueGray-700 font-medium"
  }, [_vm._v("Questions")])]), _vm._v(" "), _c('div', {
    staticClass: "relative bg-gray-100 overflow-y-auto rounded border border-solid border-gray-200 px-3 py-3"
  }, [_c('div', {
    staticClass: "flex justify-between items-center space-x-2",
    class: [{
      'pb-3': _vm.guiding_questions.length > 0
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_guiding_question),
      expression: "new_guiding_question"
    }],
    staticClass: "bg-white focus-within:border-gray-400 w-full py-2 px-4 rounded border border-solid border-gray-200",
    attrs: {
      "placeholder": "Enter a Question"
    },
    domProps: {
      "value": (_vm.new_guiding_question)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addEditGuidingQuestion.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_guiding_question = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "bg-blueGray-700 text-white py-2 px-4 rounded",
    on: {
      "click": _vm.addEditGuidingQuestion
    }
  }, [_vm._v("\n                  Add\n                ")])]), _vm._v(" "), _c('Draggable', {
    staticClass: "h-full flex-grow overflow-y-auto overflow-x-hidden",
    attrs: {
      "handle": ".handle"
    },
    on: {
      "start": function($event) {
        _vm.drag_content_resource = true
      },
      "end": function($event) {
        _vm.drag_content_resource = false
      }
    },
    model: {
      value: (_vm.guiding_questions),
      callback: function($$v) {
        _vm.guiding_questions = $$v
      },
      expression: "guiding_questions"
    }
  }, _vm._l((_vm.guiding_questions), function(element, index) {
    return _c('div', {
      key: element.question
    }, [_c('QuestionOption', {
      key: index,
      staticClass: "mb-1.5 w-full",
      attrs: {
        "is_active": element.is_active,
        "is_custom": element.is_custom,
        "question_name": element.question,
        "id": index
      },
      on: {
        "change_active_status": function (id_option) { return _vm.handleChangeQuestiontatus(id_option); },
        "delete_question": function (id_option) { return _vm.handleRemoveQuestion(id_option); },
        "save_information_before_edit": function (info) { return _vm.handleEditQuestion(info); }
      }
    })], 1)
  }), 0)], 1)])]), _vm._v(" "), _c('footer', {
    staticClass: "px-6 mt-3 flex justify-between"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded cursor-pointer text-gray-700 border border-solid border-gray-200",
    on: {
      "click": function($event) {
        return _vm.$emit('close', false)
      }
    }
  }, [_vm._v("\n            Cancel\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "sample px-5 py-2 bg-primary rounded cursor-pointer text-white font-medium",
    on: {
      "click": _vm.saveLiveRt
    }
  }, [_vm._v("\n            Save Changes\n          ")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-9e194a8e!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/editLiveRtModal.vue
// module id = 974
// module chunks = 61